/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

import { REMOVE_ANSWER } from "./actionTypes"
import { removeAnswerError, removeAnswerSuccess } from "./actions"

import { deleteAnswer } from "../../../helpers/backend_helper"

function* remove(request) {
  try {
    const response = yield call(deleteAnswer, request.payload.idQuestionAnswer)
    if (response == undefined) throw new Error("API error")
    yield put(removeAnswerSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(removeAnswerError(error.message))
  }
}

function* answerRemoveSaga() {
  yield takeEvery(REMOVE_ANSWER, remove)
}

export default answerRemoveSaga
